import { useParams } from 'react-router-dom';
import { useAtomValue } from 'jotai';

import { Image, ImageAndNameWrapper, Name, NameWrapper } from './index.styles';

import PlaceLikeButton from '../../../../../../common/place_like_button';
import PageWrapper from '../../../../../../page_wrapper';
import HeaderWithButton from '../../../../header_with_button';
import PlaceInfo from './place_info';
import Products from './products';

import useI18nText from '../../../../../../../hooks/useI18nText';

import { vendorBusinessState, vendorPlaceQuery } from '../../../../../../../store';

import type { Place } from '@rewardopl/types';

export default function PlacePage() {
  const { place_id: placeId } = useParams<{ place_id?: Place['_id'] }>();

  if (!placeId) {
    throw new Error('placeId is undefined');
  }

  const place = useAtomValue(vendorPlaceQuery(placeId));
  const business = useAtomValue(vendorBusinessState);

  const placeWithDefaults = {
    ...business,
    ...place,
  };

  const { name, name_i18n: nameI18n, picture } = placeWithDefaults;

  const nameString = useI18nText(nameI18n, name);

  return (
    <PageWrapper withPadding={false}>
      <HeaderWithButton
        extraButton={<PlaceLikeButton placeId={place._id} showLabel={false} />}
      >{`${nameString}, ${place.address.city}`}</HeaderWithButton>
      <ImageAndNameWrapper>
        {placeWithDefaults.picture ? (
          <Image alt={nameString} src={`/api/uploads/${picture}`} />
        ) : null}
        <NameWrapper>
          <Name>
            BUBBLEJOY
            <br />
            {nameString}
            <br />
            {place.address.city}
          </Name>
          <PlaceInfo place={placeWithDefaults} />
        </NameWrapper>
      </ImageAndNameWrapper>
      <Products placeId={placeId} />
    </PageWrapper>
  );
}
